function e(e, t, o, n = {}) {
	document.addEventListener(t, (t) => {
		t.composedPath().includes(e) && (t.stopPropagation(), t.stopImmediatePropagation(), o(t));
	}, {
		capture: !0,
		...n
	});
}
function t(e, t, o) {
	const n = {
		altKey: t.altKey,
		bubbles: t.bubbles,
		cancelable: t.cancelable,
		code: t.code,
		composed: t.composed,
		ctrlKey: t.ctrlKey,
		detail: t.detail,
		isComposing: t.isComposing,
		key: t.key,
		location: t.location,
		metaKey: t.metaKey,
		repeat: t.repeat,
		shiftKey: t.shiftKey,
		view: t.view,
		charCode: t.charCode,
		keyCode: t.keyCode,
		which: t.which,
		...o
	};
	return new KeyboardEvent(e, n);
}
function o(e, t, o) {
	const n = {
		bubbles: t.bubbles,
		cancelable: t.cancelable,
		composed: t.composed,
		detail: t.detail,
		isComposing: t.isComposing,
		view: t.view,
		which: t.which,
		data: t.data,
		dataTransfer: t.dataTransfer,
		inputType: t.inputType,
		targetRanges: "function" == typeof t.getTargetRanges ? t.getTargetRanges() : [],
		...o
	};
	return new InputEvent(e, n);
}
function n(e, t, o) {
	const n = {
		bubbles: t.bubbles,
		cancelable: t.cancelable,
		composed: t.composed,
		detail: t.detail,
		view: t.view,
		which: t.which,
		altKey: t.altKey,
		button: t.button,
		buttons: t.buttons,
		clientX: t.clientX,
		clientY: t.clientY,
		ctrlKey: t.ctrlKey,
		metaKey: t.metaKey,
		shiftKey: t.shiftKey,
		movementX: t.movementX,
		movementY: t.movementY,
		screenX: t.screenX,
		screenY: t.screenY,
		relatedTarget: t.relatedTarget,
		modifierAltGraph: t.getModifierState("AltGraph"),
		modifierCapsLock: t.getModifierState("CapsLock"),
		modifierFn: t.getModifierState("Fn"),
		modifierFnLock: t.getModifierState("FnLock"),
		modifierHyper: t.getModifierState("Hyper"),
		modifierNumLock: t.getModifierState("NumLock"),
		modifierScrollLock: t.getModifierState("ScrollLock"),
		modifierSuper: t.getModifierState("Super"),
		modifierSymbol: t.getModifierState("Symbol"),
		modifierSymbolLock: t.getModifierState("SymbolLock"),
		...o
	};
	return new MouseEvent(e, n);
}
function i(e, t, o) {
	const n = {
		bubbles: t.bubbles,
		cancelable: t.cancelable,
		composed: t.composed,
		detail: t.detail,
		view: t.view,
		which: t.which,
		relatedTarget: t.relatedTarget,
		...o
	};
	return new FocusEvent(e, n);
}
const r = () => "undefined" == typeof navigator ? void 0 : navigator, a = () => /Mobi/i.test(r()?.userAgent ?? ""), c = () => {
	const e = r(), t = e?.userAgent ?? "";
	return /iPad|Tablet|PlayBook|Silk/i.test(t) || /Android/i.test(t) && !/Mobi/i.test(t) || /Macintosh/i.test(t) && (e?.maxTouchPoints ?? 0) > 1;
};
function s(e) {
	return "string" != typeof e ? "" : e.replace(/[۰-۹]/g, function(e) {
		return String.fromCharCode(e.charCodeAt(0) - 1728);
	});
}
function l(e) {
	return "string" != typeof e && isNaN(e) ? "" : e.toString().replace(/[0-9]/g, function(e) {
		return String.fromCharCode(e.charCodeAt(0) + 1728);
	});
}
function d(e, t = document) {
	const o = new CSSStyleSheet();
	return o.replaceSync(e), t.adoptedStyleSheets.push(o), o;
}
function u(e = "") {
	return crypto?.randomUUID ? `${e}-${crypto.randomUUID()}` : `${e}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function m(e, t = !1) {
	return null === e ? t : "" === e || "true" === e.toLowerCase() || "false" !== e.toLowerCase() && Boolean(e);
}
function f(e, t = 0) {
	if (null === e || "" === e.trim()) return t;
	const o = Number(e);
	return Number.isFinite(o) ? o : t;
}
const b = globalThis.HTMLElement ?? class {};
function p(e, t) {
	"undefined" == typeof customElements || customElements.get(e) || customElements.define(e, t);
}
export { b as JBBaseComponent, i as createFocusEvent, o as createInputEvent, t as createKeyboardEvent, n as createMouseEvent, p as defineWebComponent, l as enToFaDigits, s as faToEnDigits, d as injectCss, a as isMobile, c as isTablet, e as listenAndSilentEvent, m as parseBooleanAttribute, f as parseNumberAttribute, u as uniqueId };

//# sourceMappingURL=index.js.map